import { useCallback } from 'react';
import { DutyMutationTypeEnum } from './useMutateDutyLinesInBulk.types';
import { isRowNominal } from '../HoursTable.utils';
import { DeleteDeps } from '../HoursTable.types';

export function useDeleteHandler({
  employeeId,
  isEmployeePortal,
  deleteDutyLine,
  mutateDutyLinesInBulk
}: DeleteDeps) {
  const handleDelete = useCallback(
    async (_event: any, row: any) => {
      if (!row) return;
      const target = Array.isArray(row) ? row[0] : row;
      if (!target) return;

      if (isRowNominal(target)) {
        await mutateDutyLinesInBulk({
          employeeId,
          isEmployeePortal,
          dutyLineIds: target.dutyLineId,
          type: DutyMutationTypeEnum.DELETE
        });
      } else if (target.requestId) {
        await deleteDutyLine({
          employeeId,
          isEmployeePortal,
          requestId: target.requestId
        });
      }
    },
    [employeeId, isEmployeePortal, deleteDutyLine, mutateDutyLinesInBulk]
  );

  return { handleDelete };
}
